



































import { defineComponent, computed, ComputedRef, ref, Ref, onMounted } from '@vue/composition-api';

import ChannelListData from '@/ts/Channels/ChannelListData';
import { Actions, Mutations } from '@/ts/store/modules/Channels/constants';

import ChannelListHeader from './components/ChannelListHeader.vue';
import TabSelectors from './components/TabSelectors.vue';
import ChannelListItem from './components/ChannelListItem.vue';

import ChannelCreate from '../ChannelCreate/ChannelCreate.vue';


export default defineComponent({
  components: {
    ChannelListHeader,
    TabSelectors,
    ChannelListItem,
    ChannelCreate,
  },
  setup(props, context) {

    const store = context.root.$store;
    // @ts-ignore
    const router = context.root.$router;

    const selectedTab: Ref<'joined' | 'explore'> = ref('joined');  
    const showCreateChannelModal: Ref<boolean> = ref(false); 

    const joinedChannelList: ComputedRef<ChannelListData[]> = computed(() => {
      return store.getters['Channels/getJoinedChannelList'];
    });

    const availableChannelList: ComputedRef<ChannelListData[]> = computed(() => {
      return store.getters['Channels/getAvailableChannelList'];
    });

    const onChannelSelect = (channel: ChannelListData) => {
      store.commit(Mutations.SET_SELECTED_CHANNEL, channel);
      router.push({name: 'user-channel', params: { channelId: channel.id }});
    };

    const onChannelJoin = (id) => {
      store.dispatch(Actions.JOIN_CHANNEL, id);
    };

    const onOpenCreateChannelModal = () => {
      showCreateChannelModal.value = true;
    };

    const onCloseCreateChannelModal = () => {
      showCreateChannelModal.value = false;
    };

    onMounted(() => {
      store.dispatch(Actions.FETCH_JOINED_CHANNEL_LIST);
      store.dispatch(Actions.FETCH_AVAILABLE_CHANNEL_LIST);
    });

    return {
      joinedChannelList,
      availableChannelList,
      selectedTab,
      showCreateChannelModal,
      onChannelSelect,
      onChannelJoin,
      onOpenCreateChannelModal,
      onCloseCreateChannelModal,
    };
  },
});
